import React from 'react'
import Imgix from 'react-imgix'
import styled from 'styled-components'
import ParagraphComponent from '../ParagraphComponent'
import useStyles from './FeatureColumnsComponent.styles'
import PrimaryButton from '../../utils/PrimaryButton'
import { FeatureColumnsComponentProps } from './FeatureColumnsComponentProps'
import mapStyles from '../../utils/mapStyles'
import { StyleBlock } from '../../../data/types/StyleBlock'
import MediaQueryName from '../../../data/types/MediaQueryName'
import MediaQueries from '../../../styles/MediaQueries'

const FeatureColumns = styled.div<{styles?: Record<MediaQueryName, StyleBlock>}>`
  padding: ${
    ({styles}) => styles?.[MediaQueryName.Default]?.paddingHeight ?? 64.5
  }px 57px ${
    ({styles}) => styles?.[MediaQueryName.Default]?.paddingHeight ?? 26.5
  }px 57px;

  @media ${MediaQueries.Tablet.substring(6)} {
    padding: ${({styles}) =>  styles?.[MediaQueryName.Tablet]?.paddingHeight ?? 84}px 0px;
  }

  @media ${MediaQueries.LaptopSmall.substring(6)} {
    padding: ${({styles}) =>  styles?.[MediaQueryName.LaptopSmall]?.paddingHeight ?? 207}px 0px;
  }

  @media ${MediaQueries.LaptopLarge.substring(6)} {
    padding: ${({styles}) =>  styles?.[MediaQueryName.LaptopLarge]?.paddingHeight ?? 207}px 0px;
  }

  @media ${MediaQueries.Desktop.substring(6)} {
    padding: ${({styles}) =>  styles?.[MediaQueryName.Desktop]?.paddingHeight ?? 200}px 0px;
  }
`

const FeatureColumnsComponent: React.FC<FeatureColumnsComponentProps> = ({
  columns,
  title,
  paragraphStyles
}) => {
  const styleMap = mapStyles(paragraphStyles)
  const classes = useStyles()

  return (
    <div className={classes.featureColumnsContainer}>
      <div className={classes.featureColumnsTitle}>{title}</div>
      {/* Render the features and buttons in a grid to align the buttons on the same level 
    and ensure all synopsis summaries have the same height */}
      <div className={classes.gridContainer}>
        <FeatureColumns className={classes.featuresRow} styles={styleMap}>
          {columns.map(({ image, text }) => (
            <div key={image.src} className={classes.gridItem}>
              <Imgix src={image.src} className={classes.image} />
              {/* Buttons will be rendered in ParagraphComponent on mobile view */}
              <ParagraphComponent {...text} className={classes.text} inFeatureColumns />
            </div>
          ))}
        </FeatureColumns>

        {/* Buttons will be rendered at here on web view */}
        <FeatureColumns className={classes.buttonsRow} styles={styleMap}>
          {columns.map(({ text }, index) => (
            <div key={index} className={classes.gridItem}>
            {text.button && (
              <PrimaryButton
                isPrimary={text.button.isPrimary}
                href={text.button.href}
              >
                {text.button.text}
              </PrimaryButton>
            )}
            </div>
          ))}
        </FeatureColumns>
      </div>
    </div>
  )
}

export default FeatureColumnsComponent
